var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
/* eslint-disable max-lines */
import { comparer } from 'mobx';
import { merge } from 'bernie-core';
import { DeviceType } from 'bernie-context';
import { Localization } from 'bernie-l10n';
import { CurrentHotelStore } from 'stores/current-hotel-store';
import { isVRBO } from 'stores/context-store-utils';
import { SearchCriteriaModel, SearchCriteriaUtils, singleUseQueryParams, untrackedQueryParams } from 'stores/models';
import { DEFAULT_HOTEL_INFOSITE_PAGE_ID, DEFAULT_HOTEL_INFOSITE_PAGE_NAME } from 'constants/pages';
import { MarketingChannels } from 'constants/marketing-channels';
import { getHotelInfositePageData } from 'src/common/utils/controller-utils/page-data-util';
import { getSeoData } from 'src/common/utils/controller-utils/get-seo-data';
import { getTrackingInfoForLogging } from 'utils/logging-utils';
import { meta } from 'utils/meta';
import { processClientSideDefaultRequestFields } from 'controllers/hotel/shared-controller-modules/utils';
import { CONTROLLER_EVENTS } from 'controllers/events/controller-events';
import loadable from '@loadable/component';
const {
  withoutKeys,
  withKeys
} = merge;
export class InfositeController {
  constructor() {
    this.bundles = ['infosite'];
    // @ts-ignore
    this.component = loadable({
      resolved: {},
      chunkName() {
        return "infosite";
      },
      isReady(props) {
        const key = this.resolve(props);
        if (this.resolved[key] !== true) {
          return false;
        }
        if (typeof __webpack_modules__ !== 'undefined') {
          return !!__webpack_modules__[key];
        }
        return false;
      },
      importAsync: () => import( /* webpackChunkName: "infosite" */'views/hotel/infosite.tsx'),
      requireAsync(props) {
        const key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(resolved => {
          this.resolved[key] = true;
          return resolved;
        });
      },
      requireSync(props) {
        const id = this.resolve(props);
        if (typeof __webpack_require__ !== 'undefined') {
          return __webpack_require__(id);
        }
        return eval('module.require')(id);
      },
      resolve() {
        if (require.resolveWeak) {
          return require.resolveWeak("views/hotel/infosite.tsx");
        }
        return eval('require.resolve')("views/hotel/infosite.tsx");
      }
    });
    this.pageId = DEFAULT_HOTEL_INFOSITE_PAGE_ID;
    this.path = '/:langOrLocale([a-z]{2}-[a-z]{2}|[a-z]{2})?/:descriptor?/:prefix(ho|.*.?h)?:propertyId(p?\\d+[a-z]*):suffix(/?.*)?';
    this.exact = false;
    this.routeName = 'infosite';
    this.routeData = {
      rfrrNamespace: 'HOT.HIS',
      pageName: DEFAULT_HOTEL_INFOSITE_PAGE_NAME
    };
  }
  fetchPageData(options) {
    const context = options.context;
    return Promise.resolve(Object.assign(Object.assign({}, getSeoData(context)), getHotelInfositePageData(options.query)));
  }
  // eslint-disable-next-line complexity
  fetch(options) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    return __awaiter(this, void 0, void 0, function* () {
      if (!options || !options.stores) {
        return Promise.reject('InfositeController.fetch received invalid FetchOptions');
      }
      const {
        isServer,
        stores,
        query,
        params,
        logger
      } = options;
      const fetchStartTime = Date.now();
      const context = stores.get('context');
      const page = stores.get('page');
      const currentHotel = stores.get('currentHotel');
      const multiItem = stores.get('multiItem');
      const multiItemBusinessModel = multiItem && multiItem.cartInfo && multiItem.cartInfo.type;
      const analyticsStore = stores.get('analytics');
      const pageLayoutStore = stores.get('pageLayout');
      multiItem.isMixMatchEnabled = query.mixMatch === 'true';
      multiItem.buildContext(query);
      const _k = params || {
          prevParams: undefined
        },
        {
          prevParams
        } = _k,
        nextParams = __rest(_k, ["prevParams"]);
      // for a server side rendered PDP on Vrbo and Hcom - leverage the blacksmith /v2/urlBuild call in the flex catalyst plugin which requests
      // the canonical PDP url and expedia property id from blacksmith. this removes the dependency on the expediaPropetyId url parameter
      // for SSR'd PDPs on Vrbo and Hcom
      if ((isVRBO(context) || context.site.brand === 'hotels') && ((_c = (_b = (_a = context === null || context === void 0 ? void 0 : context.seoData) === null || _a === void 0 ? void 0 : _a.anvilRequest) === null || _b === void 0 ? void 0 : _b.identifiers) === null || _c === void 0 ? void 0 : _c.hotel) !== undefined && ((_f = (_e = (_d = context === null || context === void 0 ? void 0 : context.seoData) === null || _d === void 0 ? void 0 : _d.anvilRequest) === null || _e === void 0 ? void 0 : _e.identifiers) === null || _f === void 0 ? void 0 : _f.hotel) !== nextParams.propertyId) {
        nextParams.propertyId = (_j = (_h = (_g = context === null || context === void 0 ? void 0 : context.seoData) === null || _g === void 0 ? void 0 : _g.anvilRequest) === null || _h === void 0 ? void 0 : _h.identifiers) === null || _j === void 0 ? void 0 : _j.hotel;
      }
      // query params cleanup
      const singleUseCriteria = withKeys(singleUseQueryParams).merge({}, options.query);
      const untrackedKeys = [...untrackedQueryParams, ...Object.keys(singleUseCriteria), 'prevQuery', 'l10n'];
      const prevQuery = withoutKeys(untrackedKeys).merge({}, query.prevQuery);
      const nextQuery = withoutKeys(untrackedKeys).merge({}, query);
      if (multiItemBusinessModel && nextQuery) {
        nextQuery.businessModelFilter = multiItemBusinessModel;
      }
      let newQuery = processClientSideDefaultRequestFields(isServer, currentHotel, nextQuery);
      if (newQuery) {
        return newQuery;
      }
      const l10n = new Localization(context.locale);
      currentHotel.searchCriteria = new SearchCriteriaModel(SearchCriteriaUtils.ensureCorrectTypes(currentHotel.searchCriteria), l10n);
      // Fetch Template details for React View Composer
      const pageLayoutTemplatePromise = pageLayoutStore.fetchPDP(nextParams.propertyId, context, multiItem.isPackageShoppingPath());
      const forceFetch = currentHotel.shouldFetch;
      if (forceFetch || !comparer.structural(nextParams, prevParams) || !comparer.structural(prevQuery, nextQuery)) {
        // TEMP FIX: check removal after 2018-05-01 with @dboerner
        this.removeRegionIdForSEMUrls(nextQuery);
        // =====================================================
        const parsedInfositeValues = SearchCriteriaUtils.ensureCorrectTypes(SearchCriteriaUtils.parseInfositeValues(Object.assign({}, nextQuery), l10n, context.localDateFormat, isVRBO(context)));
        const incomingSearchCriteria = new SearchCriteriaModel(parsedInfositeValues, l10n);
        const criteriaChanged = this.haveCriteriaChanged(currentHotel.searchCriteria, incomingSearchCriteria, Object.keys(MarketingChannels));
        // 33486_PWA_Large_Party_Mix_Match reset cart if rooms or dates criteria changes
        const mixMatchCriteriaChanged = this.hasRoomsOrDatesChanged(currentHotel.searchCriteria, incomingSearchCriteria);
        if (multiItem && multiItem.showMixMatchExperience && mixMatchCriteriaChanged) {
          multiItem.emptyCart(context).then(() => {
            if (analyticsStore) {
              analyticsStore.trackEvent('MixMatch.EmptyCart', 'MixMatch Cart Emptied', null, null, true);
            }
          });
        }
        if (forceFetch || criteriaChanged || this.hasPropertyChanged(prevParams, nextParams)) {
          currentHotel.setOfferData(withKeys(CurrentHotelStore.offerSearchKeys).merge({}, parsedInfositeValues));
          currentHotel.updateSearchCriteria(incomingSearchCriteria);
          currentHotel.setHotelId(nextParams.propertyId);
          currentHotel.clearPoiData();
          // keep the main searchCriteria store used in srp in sync with pdp/infosite/current hotel searchCriteria
          // this will prevent firing duplicate queries when navigating from PDP -> SRP
          this.updateSearchCriteriaStore(stores, incomingSearchCriteria);
          if (isServer) {
            return;
          }
          if (!page.seo) {
            const pageFetch = page.fetch(meta['hotel-infosite'], context.site, context.locale);
            yield pageFetch;
          }
        }
      }
      yield pageLayoutTemplatePromise;
      logger.logEvent(CONTROLLER_EVENTS.INFOSITE_CONTROLLER_FETCH, `fetchTime=${(Date.now() - fetchStartTime).toString()} ms`, `, isServer=${isServer}, ${getTrackingInfoForLogging(context)}`);
      newQuery = processClientSideDefaultRequestFields(isServer, currentHotel, nextQuery);
      if (newQuery) {
        return newQuery;
      }
    });
  }
  willDeactivate(options) {
    var _a, _b, _c, _d, _e;
    return __awaiter(this, void 0, void 0, function* () {
      if (!options || !options.stores) {
        return Promise.reject('InfositeController.willDeactivate receieved an invalid StoreContainer');
      }
      const currentHotel = options.stores.get('currentHotel');
      if (currentHotel.isFailure) {
        currentHotel.shouldFetch = true;
      }
      const experiments = options.stores.get('experiment');
      const context = options.stores.get('context');
      const multiItem = options.stores.get('multiItem');
      const pageLayoutStore = options.stores.get('pageLayout');
      const isMobileWeb = ((_a = context.deviceInformation) === null || _a === void 0 ? void 0 : _a.type) === DeviceType.MOBILE_PHONE;
      const useBEXQuickFiltersTemplate = isMobileWeb ? ((_c = (_b = experiments === null || experiments === void 0 ? void 0 : experiments.exposures) === null || _b === void 0 ? void 0 : _b.Introduce_Quick_Sort_and_Filters_at_top_of_SRP_mweb) === null || _c === void 0 ? void 0 : _c.bucket) === 1 : ((_e = (_d = experiments === null || experiments === void 0 ? void 0 : experiments.exposures) === null || _d === void 0 ? void 0 : _d.Introduce_Quick_Sort_and_Filters_at_top_of_SRP_web) === null || _e === void 0 ? void 0 : _e.bucket) === 1;
      pageLayoutStore.setSRPTemplate(context, multiItem.isPackageShoppingPath(), useBEXQuickFiltersTemplate);
    });
  }
  removeRegionIdForSEMUrls(query) {
    // TODO: SEM regionId fix (do not remove until SEM URLs have been fixed)
    if (query && /google/gi.test(query.semcid)) {
      delete query.regionId;
    }
  }
  hasPropertyChanged(prevParams, nextParams) {
    if (prevParams && nextParams && prevParams.propertyId && nextParams.propertyId) {
      return prevParams.propertyId !== nextParams.propertyId;
    }
    return false;
  }
  haveCriteriaChanged(previousModel, newModel, ignoredKeys) {
    if (Boolean(newModel) && !previousModel) {
      return true;
    }
    return !comparer.structural(previousModel.toJSON(ignoredKeys), newModel.toJSON(ignoredKeys));
  }
  hasRoomsOrDatesChanged(previousModel, newModel) {
    if (newModel && !previousModel) {
      return true;
    }
    const startDateChanged = previousModel.startDate !== newModel.startDate;
    const endDateChanged = previousModel.endDate !== newModel.endDate;
    return !comparer.structural(previousModel.rooms, newModel.rooms) || startDateChanged || endDateChanged;
  }
  updateSearchCriteriaStore(stores, incomingSearchCriteria) {
    const searchCriteriaStore = stores.get('searchCriteria');
    searchCriteriaStore.hydrate(incomingSearchCriteria);
  }
}